import React from "react";
import { StatusBadge } from "../../ui";

/**
 * AuditLogRow — Single row for the audit logs table.
 * Shows timestamp, user, action, target entity, IP address.
 */

const ACTION_VARIANT = {
  create: "active",
  update: "trial",
  delete: "suspended",
  login: "active",
  logout: "inactive",
  suspend: "suspended",
  reactivate: "active",
  upgrade: "active",
};

const AuditLogRow = ({ log }) => {
  const variant = ACTION_VARIANT[log.action?.toLowerCase()] || "inactive";
  const time = (log.timestamp || log.createdAt)
    ? new Date(log.timestamp || log.createdAt).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

  return (
    <tr>
      <td style={{ fontSize: "0.8125rem", whiteSpace: "nowrap" }}>{time}</td>
      <td>
        <div className="fw-medium" style={{ fontSize: "0.8125rem" }}>{log.userName || "System"}</div>
        <div className="text-muted" style={{ fontSize: "0.6875rem" }}>{log.userRole || "—"}</div>
      </td>
      <td>
        <StatusBadge status={variant}>{log.action || "—"}</StatusBadge>
      </td>
      <td style={{ fontSize: "0.8125rem" }}>{log.description || "—"}</td>
      <td style={{ fontSize: "0.8125rem" }}>{log.target || "—"}</td>
      <td className="text-muted" style={{ fontSize: "0.75rem", fontFamily: "monospace" }}>
        {log.ip || "—"}
      </td>
    </tr>
  );
};

export default AuditLogRow;
